import React, { useState, useEffect, useContext } from 'react';
import Logo from 'component/logo';
import './index.css';
import Button from 'component/button';
import IconButton, { iconType } from 'component/icon-button';
import HamburgerMenu from 'component/hamburgerMenu';
import { useTranslation } from 'react-i18next';
import LanguageSelect from 'component/select';
import {getApiMenu} from 'api/data/cms';
import Themes from 'themes';

// lib
import { loginRegister as showLoginDialog } from "lib/showDialog/loginRegister";
const ThemeContext = React.createContext(Themes.themes1);

const buttons = [
  { key: 'home', iconType: iconType.home, text: 'AnimationHeader.button_home' },
  { key: 'lottery', iconType: iconType.lottery, text: 'AnimationHeader.button_lottery' },
  { key: 'sport', iconType: iconType.sport, text: 'AnimationHeader.button_sport' },
  { key: 'game', iconType: iconType.game, text: 'AnimationHeader.button_game' },
  { key: 'sale', iconType: iconType.sale, text: 'AnimationHeader.button_sale' },
  { key: 'download', iconType: iconType.download, text: 'AnimationHeader.button_download' },
];

const AnimationHeader = () => {
  const [scrolling, setScrolling] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
  const [aniHeader, setAniHeader] = useState('aniHeader');
  const [navBar, setNavBar] = useState({result:[]})
  const { t } = useTranslation();
  const Themes = useContext(ThemeContext);

  useEffect(() => {
    const onScroll = e => {
      setScrollTop(e.target.documentElement.scrollTop);
      setScrolling(e.target.documentElement.scrolling > scrollTop);
    };
    window.addEventListener('scroll', onScroll);
    if (scrollTop > 77) {
      setAniHeader('aniHeaderAction');
    } else {
      setAniHeader('aniHeader');
    }
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollTop]);

  // 等後台好要餵新的資料
  useEffect(async() => {
      const res = await getApiMenu();
      setNavBar(res);
      console.log('get navBar', res)
  },[])

  const activeKey = 'home';

  const currentLanguage = 'cn';

  const lanSelectOptions = [
    { text: '简体中文', value: 'zh-CN' },
    { text: '繁體中文', value: 'zh-TW' },
    { text: 'English', value: 'en-GB' }
  ];

  const handleLoginRegisterClick = () => {
    // demo 暫時先關掉
    // showLoginDialog().then(_ => {
    //   console.log('登入成功');
    // })
  };

  const handleNavClick = key => {
    console.log('redirect to ', key);
  };

  const handleSelect = lang => {
    console.log('new language: ', lang);
  };

  return (
    <div className={aniHeader} style={{ background: Themes.headerbg }}>
      <HamburgerMenu />
      <Logo />
      <div className="functionalArea">
        {buttons.map(({ key, iconType, text }) => (
          <IconButton key={key} active={key === activeKey} iconType={iconType} onClick={() => handleNavClick(key)}>
            {t(text)}
          </IconButton>
        ))}
        <Button highlight onClick={handleLoginRegisterClick}>
          {t('AnimationHeader.button_login_register')}
        </Button>
        <LanguageSelect options={lanSelectOptions} value={currentLanguage} onSelect={handleSelect} />
      </div>
    </div>
  );
};

export default AnimationHeader;
